import { render, staticRenderFns } from "./WalletBonus.vue?vue&type=template&id=f4089fc2&"
import script from "./WalletBonus.vue?vue&type=script&lang=js&"
export * from "./WalletBonus.vue?vue&type=script&lang=js&"
import style0 from "./WalletBonus.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports